// Create a custom hook to interact with the modal context provider.

import { useContext } from 'react';

import { ModalContext } from '@/shared/hooks/context/modalContext';

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
